import React from 'react';
import pt from 'prop-types';
import Icon from 'components/icon';
import { classNames } from 'utils';
import { writeToClipboard } from 'utils/clipboard';
import Label from './label';
import './input-secret.scss';

const COPIED_DURATION = 2000;

/**
 * Text input for API keys and other credentials: the value is masked until
 * revealed, and can be copied without revealing it. Stored as plain text.
 */
export default class InputSecret extends React.PureComponent {
  static propTypes = {
    id: pt.string,
    label: pt.node,
    labelRenderer: pt.func,
    help: pt.oneOfType([pt.node, pt.object]),
    value: pt.string,
    className: pt.string,
    disabled: pt.bool,
    onChange: pt.func,
  };

  // Field focuses and selects through this ref
  inputRef = React.createRef();

  state = {
    revealed: false,
    copied: false,
  };

  componentWillUnmount() {
    clearTimeout(this.copiedTimeout);
  }

  onClickReveal = () => {
    this.setState({ revealed: !this.state.revealed });
  };

  onClickCopy = () => {
    writeToClipboard(this.props.value);

    clearTimeout(this.copiedTimeout);
    this.setState({ copied: true });
    this.copiedTimeout = setTimeout(
      () => this.setState({ copied: false }),
      COPIED_DURATION,
    );
  };

  render() {
    const { label, labelRenderer, help, value, className, ...props } =
      this.props;
    const { revealed, copied } = this.state;

    return (
      <span className="form-secret">
        {label && (
          <Label
            label={label}
            labelRenderer={labelRenderer}
            help={help}
            htmlFor={props.id}
          />
        )}

        <span className="form-secret-group">
          <input
            {...props}
            ref={this.inputRef}
            type={revealed ? 'text' : 'password'}
            value={value || ''}
            className={classNames(className, {
              disabled: Boolean(props.disabled),
            })}
            // Keep browsers and password managers from filling in or saving
            // the user's own login here
            autoComplete="new-password"
            data-1p-ignore
            data-lpignore="true"
          />

          <button
            type="button"
            className="button button-sm button-secondary form-secret-reveal"
            aria-label={revealed ? 'Hide' : 'Show'}
            title={revealed ? 'Hide' : 'Show'}
            onClick={this.onClickReveal}
          >
            <Icon fa={revealed ? 'eye-slash' : 'eye'} />
          </button>

          <button
            type="button"
            className="button button-sm button-secondary form-secret-copy"
            disabled={!value}
            onClick={this.onClickCopy}
          >
            <Icon fa={copied ? 'check' : 'copy'} />
            {copied ? 'Copied' : 'Copy'}
          </button>
        </span>
      </span>
    );
  }
}
